import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SidebarAccountVisibilityState {
  hiddenAccountIds: string[];
  isAccountVisible: (accountId: string) => boolean;
  toggleAccountVisibility: (accountId: string) => void;
}

export const useSidebarAccountVisibilityStore = create<SidebarAccountVisibilityState>()(
  devtools(
    (set, get) => ({
      hiddenAccountIds: [],
      isAccountVisible: (accountId: string) => {
        return !get().hiddenAccountIds.includes(accountId);
      },
      toggleAccountVisibility: (accountId: string) => {
        set((state) => {
          const isCurrentlyHidden = state.hiddenAccountIds.includes(accountId);
          
          if (isCurrentlyHidden) {
            return {
              hiddenAccountIds: state.hiddenAccountIds.filter(id => id !== accountId),
            };
          } else {
            return {
              hiddenAccountIds: [...state.hiddenAccountIds, accountId],
            };
          }
        });
      },
    }),
    { name: 'SidebarAccountVisibilityStore', enabled: process.env.NODE_ENV !== 'production' }
  )
);
